import { Group } from '@/router/group.model';
import { socialMediaAssets } from '@/router/routes';
import { loyaltyProgramGroup } from './loyalty-program';
import { sellCoinsGroup } from './sell-coins';
import {
  activationEmails,
  customerImport,
  offerWelcomeCoins,
  referralProgram,
  sellCoins,
  socialRewards,
  customerImportInStore,
  specialCoinsOffers
} from '../routes';

const routes = [
  offerWelcomeCoins,
  specialCoinsOffers,
  customerImportInStore,
  sellCoins,
  sellCoinsGroup,
  referralProgram,
  customerImport,
  activationEmails,
  socialRewards,
  socialMediaAssets,
  loyaltyProgramGroup
];

const myToolsGroup = new Group('My Tools', 'my-tools', routes, {
  superRoot: false,
  icon: 'tools',
  description:
    'Build a customized marketing solution in minutes using these features!'
});

export { myToolsGroup };
export default myToolsGroup;
